/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';

import { IListClubReturn } from '../interfaces/club';
import { ClubStatusManager } from '../services/manager';
import { getAllClubs, getClubBySport, getClubBySportSelect } from '../services/club';
import { listClubActions, listClubSelectActions } from './definition';

function clubError(e: string, commune: any) {
    return {
        type: listClubActions.LIST_CLUB_ERROR,
        error: e,
        data: commune,
    };
}

// Reducers of Single Club
function clubIsLoading() {
    return {
        type: listClubActions.LIST_CLUB_IS_LOADING,
    };
}

const clubListReset = () => {
    return {
        type: listClubActions.LIST_CLUB_RESET,
    };
};



// Recuders of Club Collection
function clubIsLoadingList() {
    return {
        type: listClubActions.LIST_CLUB_IS_LOADING,
    };
}

function clubErrorList(e: string) {
    return {
        type: listClubActions.LIST_CLUB_ERROR,
        error: e,
    };
}

function clubSetList(clubs: any) {
    return {
        type: listClubActions.LIST_CLUB,
        data: clubs,
    };
}


function clubSetListSelect(clubs: any) {
    return {
        type: listClubSelectActions.LIST_CLUB_SELECT_LIST,
        data: clubs,
    };
}


function clubSelectError(e: string, commune: any) {
    return {
        type: listClubSelectActions.LIST_CLUB_SELECT_ERROR,
        error: e,
        data: commune,
    };
}

// Reducers of Single Club
function clubSelectIsLoading() {
    return {
        type: listClubSelectActions.LIST_CLUB_SELECT_IS_LOADING,
    };
}

const clubSelectListReset = () => {
    return {
        type: listClubSelectActions.LIST_CLUB_SELECT_RESET,
    };
};
/**
 * Reducer to rest a clubs
 * @param values Data to reset clubs
 */
export const resetStateClub = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubListReset());
    };
};

/**
 * Reducer to rest a clubs
 * @param values Data to reset clubs
 */
export const resetClubReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubListReset());
    };
};

/**
 * Reducer to rest a clubs
 * @param values Data to reset clubs
 */
 export const resetClubSelectReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubSelectListReset());
    };
};

/**
 * Reducer to reset Clubs
 * @param values Values to reset clubs
 */
export const resetClub = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubListReset());
    };
};

// List

/**
 * Reducer to get all the clubs
 */
export const fetchListClubs = (paginate = 1, limit = 999, search = '') => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubIsLoadingList());
        await getAllClubs(paginate, limit, search)
            .then((response: IListClubReturn) => {
                if (response.statusCode === ClubStatusManager.CLUB_LISTED) {
                    dispatch(clubSetList(response.data));
                } else {
                    dispatch(clubErrorList(response.message));
                }
            })
            .catch((error) => {
                dispatch(clubErrorList(error));
            });
    };
};

/**
 * Reducer to get a club by id
 * @param id Id of club to find
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getClubBysport = (query) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubIsLoading());
        try {
            const response = await getClubBySport(query);
            if (response?.statusCode === ClubStatusManager.CLUB_LISTED && response.data) {
                dispatch(clubSetList(response));
            } else {
                dispatch(clubError('Could not get club: ', query.sport));
            }
        } catch (error: any) {
            const Err = {
                data: query,
                message: error,
                code: 'NOT_FOUNT',
            }
            dispatch(clubError('No se pudo obtener el club', Err ));
        }
    };
};


/**
 * Reducer to get a club by id
 * @param id Id of club to find
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getClubBysportSelect = (query) => {
    //console.log('aqui 9********', { query })
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(clubSelectIsLoading());
        try {
            const response = await getClubBySportSelect(query);
            if (response?.statusCode === ClubStatusManager.CLUB_LISTED && response.data) {
                dispatch(clubSetListSelect(response));
            } else {
                dispatch(clubSelectError('Could not get club: ', query.sport));
            }
        } catch (error: any) {
            const Err = {
                data: query,
                message: error,
                code: 'NOT_FOUNT',
            }
            dispatch(clubSelectError('No se pudo obtener el club', Err ));
        }
    };
};
